import React from "react";
import { Container } from "react-bootstrap";
import Project1 from "../assets/Images/Home/KGM-86.jpg";
import logo from "../assets/Images/Logos/Logo_white.png";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../utils/responsive";
export default function BannerImg() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();
  return (
    <Container fluid className="p-0">
      <div className="d-flex justify-content-center">
        {!isMobile && (
          <div
            className="border-bottom-black border-right-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
        <div
          className="border-bottom-black"
          style={{
            width: isMobile ? "100%" : "90%",
            cursor: "pointer",

            position: "relative", // Needed for positioning the overlay and text
            maxHeight: "400px", // Limit the height of the container
            overflow: "hidden", // Prevent content from overflowing
          }}
          onClick={() => {
            navigate("/home");
            window.scrollTo(0, 0);
          }}
        >
          {/* Image */}
          <img
            src={Project1}
            alt="Profile 1"
            style={{
              width: "100%", // Full width
              height: "100%", // Full height
              objectFit: "cover", // Cover entire space
            }}
          />
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.7)", // Light black overlay
            }}
          ></div>

          {/* Centered Text */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)", // Center the text
              color: "white", // White text
              textAlign: "center", // Center align text
              fontFamily: "BodoniModa-VariableFont_wght", // Optional font
              fontSize: "8rem", // Adjust text size
            }}
          >
            <img
              src={logo}
              alt="logo"
              style={{
                width: isMobile ? "250px" : "450px",
                height: isMobile ? "250px" : "450px",
              }}
            />
          </div>
        </div>
        {!isMobile && (
          <div
            className="border-bottom-black border-left-black"
            style={{
              width: "5%",
            }}
          ></div>
        )}
      </div>
    </Container>
  );
}
